import React from 'react'
import SelectBase from 'react-select'

export const SimpleSelect = (props) => {
    return (
        <SelectBase {...props}/>
    );
}
